// ─── Export Excel (.xlsx) sans dépendance ────────────────────────────────────
// Un classeur d'UNE feuille, écrit à la main : quatre fichiers XML dans une
// archive zip non compressée. Pas de bibliothèque : le paquet npm `xlsx` est
// figé sur une version signalée vulnérable, et exceljs pèserait plus lourd que
// tout le reste du bundle pour produire un tableau.
//
// colonnes : [{ l: 'Libellé', v: (ligne) => valeur, type: 'texte'|'nombre'|'date' }]
// Une date est attendue en 'AAAA-MM-JJ' (ou Date) et écrite en vraie date
// Excel — triable et filtrable, pas du texte.

const XML = (s) => String(s)
  // Caractères de contrôle interdits en XML (hors tabulation / retours).
  // eslint-disable-next-line no-control-regex
  .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const colonneLettre = (i) => {
  let s = ''; i += 1;
  while (i > 0) { const r = (i - 1) % 26; s = String.fromCharCode(65 + r) + s; i = Math.floor((i - 1) / 26); }
  return s;
};

// Numéro de série Excel d'une date (jours depuis le 30/12/1899, UTC).
const serieExcel = (d) => {
  const t = d instanceof Date ? d : new Date(`${String(d).slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(t.getTime())) return null;
  return Math.round((Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()) - Date.UTC(1899, 11, 30)) / 86400000);
};

function feuille(colonnes, lignes) {
  const cellule = (ref, val, type, style) => {
    if (val == null || val === '') return '';
    if (type === 'nombre') {
      const n = Number(val);
      return Number.isFinite(n) ? `<c r="${ref}"${style ? ` s="${style}"` : ''}><v>${n}</v></c>` : '';
    }
    if (type === 'date') {
      const n = serieExcel(val);
      return n == null ? '' : `<c r="${ref}" s="2"><v>${n}</v></c>`;
    }
    return `<c r="${ref}" t="inlineStr"${style ? ` s="${style}"` : ''}><is><t xml:space="preserve">${XML(val)}</t></is></c>`;
  };
  const entete = `<row r="1">${colonnes.map((c, j) => cellule(`${colonneLettre(j)}1`, c.l, 'texte', 1)).join('')}</row>`;
  const corps = lignes.map((l, i) => {
    const r = i + 2;
    return `<row r="${r}">${colonnes.map((c, j) => cellule(`${colonneLettre(j)}${r}`, c.v(l), c.type, c.type === 'nombre' ? 3 : 0)).join('')}</row>`;
  }).join('');
  const larg = colonnes.map((c, j) => `<col min="${j + 1}" max="${j + 1}" width="${c.largeur || 16}" customWidth="1"/>`).join('');
  const der = `${colonneLettre(colonnes.length - 1)}${lignes.length + 1}`;
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<sheetViews><sheetView workbookViewId="0"><pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews>
<cols>${larg}</cols><sheetData>${entete}${corps}</sheetData>
<autoFilter ref="A1:${der}"/></worksheet>`;
}

const STYLES = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<numFmts count="1"><numFmt numFmtId="164" formatCode="#,##0"/></numFmts>
<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><name val="Calibri"/></font></fonts>
<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>
<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>
<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>
<cellXfs count="4">
<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
<xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/>
<xf numFmtId="14" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/>
<xf numFmtId="164" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1"/>
</cellXfs>
<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>`;

// ─── Zip « stocké » (sans compression) ───────────────────────────────────────
const TABLE_CRC = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let k = 0; k < 8; k += 1) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();
const crc32 = (b) => {
  let c = 0xFFFFFFFF;
  for (let i = 0; i < b.length; i += 1) c = TABLE_CRC[(c ^ b[i]) & 0xFF] ^ (c >>> 8);
  return (c ^ 0xFFFFFFFF) >>> 0;
};

function zip(fichiers) {
  const enc = new TextEncoder();
  const locaux = []; const centraux = []; let decalage = 0;
  fichiers.forEach(({ nom, contenu }) => {
    const n = enc.encode(nom); const d = enc.encode(contenu); const crc = crc32(d);
    const h = new DataView(new ArrayBuffer(30));
    h.setUint32(0, 0x04034b50, true); h.setUint16(4, 20, true); h.setUint16(6, 0x0800, true);
    h.setUint16(8, 0, true); h.setUint32(14, crc, true); h.setUint32(18, d.length, true);
    h.setUint32(22, d.length, true); h.setUint16(26, n.length, true);
    locaux.push(new Uint8Array(h.buffer), n, d);
    const c = new DataView(new ArrayBuffer(46));
    c.setUint32(0, 0x02014b50, true); c.setUint16(4, 20, true); c.setUint16(6, 20, true); c.setUint16(8, 0x0800, true);
    c.setUint32(16, crc, true); c.setUint32(20, d.length, true); c.setUint32(24, d.length, true);
    c.setUint16(28, n.length, true); c.setUint32(42, decalage, true);
    centraux.push(new Uint8Array(c.buffer), n);
    decalage += 30 + n.length + d.length;
  });
  const tailleCentral = centraux.reduce((a, x) => a + x.length, 0);
  const fin = new DataView(new ArrayBuffer(22));
  fin.setUint32(0, 0x06054b50, true); fin.setUint16(8, fichiers.length, true); fin.setUint16(10, fichiers.length, true);
  fin.setUint32(12, tailleCentral, true); fin.setUint32(16, decalage, true);
  return new Blob([...locaux, ...centraux, new Uint8Array(fin.buffer)],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
}

export function exporterXlsx(nomFichier, nomFeuille, colonnes, lignes) {
  const feuilleNom = XML(String(nomFeuille).replace(/[\\/?*[\]:]/g, ' ').slice(0, 31));
  const blob = zip([
    { nom: '[Content_Types].xml', contenu: `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
<Default Extension="xml" ContentType="application/xml"/>
<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
</Types>` },
    { nom: '_rels/.rels', contenu: `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>
</Relationships>` },
    { nom: 'xl/workbook.xml', contenu: `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
<sheets><sheet name="${feuilleNom}" sheetId="1" r:id="rId1"/></sheets>
<definedNames><definedName name="_xlnm._FilterDatabase" localSheetId="0" hidden="1">'${feuilleNom}'!$A$1:$${colonneLettre(colonnes.length - 1)}$${lignes.length + 1}</definedName></definedNames>
</workbook>` },
    { nom: 'xl/_rels/workbook.xml.rels', contenu: `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>
<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>
</Relationships>` },
    { nom: 'xl/styles.xml', contenu: STYLES },
    { nom: 'xl/worksheets/sheet1.xml', contenu: feuille(colonnes, lignes) },
  ]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = nomFichier.endsWith('.xlsx') ? nomFichier : `${nomFichier}.xlsx`;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
